import $ from 'jquery';

import Instagram from '../components/Instagram';
import Twitter from '../components/Twitter';

export default class StaticWidgets {
  constructor(instance) {
    this.$el = $(instance.el);
    const $instagram = this.$el.find('[data-widget="instagram"]');
    const $twitter = this.$el.find('[data-widget="twitter"]');

    this.instagram = null;
    if ($instagram.length) {
      this.instagram = new Instagram($instagram);
    }

    this.twitter = null;
    if ($twitter.length) {
      this.twitter = new Twitter($twitter, instance.data);
    }

    if ($twitter.length && !$instagram.length) {
      // This timeout is needed due to a race condition when the Instagram block is removed
      setTimeout(() => {
        $('.widget-twitter-tweet div.media').find('img').css('max-height', 'unset');
      }, 1000);
    }
  }

  update($el) {
    this.instagram.init($el);
    if (this.twitter) {
      this.twitter.init($el);
    }
  }

  remove() {
    delete (this.twitter != null);

    if (this.instagram) {
      this.instagram.unload();
      delete this.instagram;
    }
  }
}
